import * as React from 'react';
import Portal from './portal';

const toggle = key => state => ({ [key]: !state[key] });

const calcPosition = ref => {
  const { left, bottom } = ref.getBoundingClientRect();

  return {
    position: 'fixed',
    left: `calc(${left}px - 16px)`,
    top: `${bottom}px`,
    padding: '5px',
    zIndex: 600,
    width: '500px',
    // backgroundColor: 'white',
    // borderRadius: '5px',
  };
};

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.dropDownRef = React.createRef();
  }
  state = {
    open: false,
  };
  onBlur = () => this.setState({ open: false });
  handleOnBlur = () => setTimeout(this.onBlur, 300);
  onInteraction = () => this.setState(toggle('open'));
  onKeyDown = e => {
    if (e.key === 'Enter') {
      this.onInteraction();
    }
  };

  render() {
    const { children, trigger, overlay, className } = this.props;

    return (
      <div
        tabIndex={0}
        role="menu"
        onClick={trigger === 'click' ? this.onInteraction : null}
        onKeyDown={this.onKeyDown}
        ref={this.dropDownRef}
        className={className || 'dropdown__block__container'}
        onBlur={this.handleOnBlur}
      >
        {children}
        {this.dropDownRef.current &&
          this.state.open && (
            <Portal overlayStyle={calcPosition(this.dropDownRef.current)}>
              {overlay}
            </Portal>
          )}
      </div>
    );
  }
}

export default Dropdown;
